// One-time onboarding hint shown in the photos gallery, styled like CreateAlbumToolTip
// (white card + left-pointing arrow). data = { text : "..." }. Positioned and shown by
// PhotosPanel, next to the photo that triggered it.
fx.ns("desktop.book.edition", class SelectionHintToolTip extends fx.Component {

	constructor(data)
	{
		super(data);

		this.effect = "hslidein";
	}

	create()
	{
		// same avatar + white card as CreateAlbumToolTip
		this.personImage = new fx.components.Image({data : fx.get("assets").splashPhoto, className : "image"});
		this.addChild(this.personImage, { width : 64, height : 64, left : 12, top : "center" });

		let text = new fx.components.Text(this.data.text);
		this.addChild(text, { left : 90, right : 16, top : 0, height : "100%" });
	}
});
